import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  CameraIcon,
  EllipsisHorizontalCircleIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import moment from "moment";

const CameraCard = ({
  camera,
  isEditState,
  onClickView,
  onClickEdit,
  hasDeletePermission,
  camAndLocation,
  onClickRemove = () => {},
  hideRemove = false,
  onClickDelete = () => {},
  hideDelete = false,
  editHidden = false,
}) => {
  const camAndLocationOption = camAndLocation?.data?.map((x) => ({
    id: x.id,
    value: x.id?.toString(),
    label: x.camerasAndLocation,
  }));

  const camsValue = camera?.camerasAndLocation?.includes(",")
    ? camera.camerasAndLocation.split(",")
    : [camera?.camerasAndLocation?.toString()];

  const filteredCamsValue = camsValue?.map((x) =>
    camAndLocationOption?.filter((b) => b?.value === x)
  );

  const filteredCameraValue = filteredCamsValue?.map(
    (x) => x?.map((x) => x)[0]
  );

  return (
    <div className="bg-white border border-gray-200 shadow-md rounded-md">
      <div className="flex p-2 gap-x-2">
        <div className="translate-y-4">
          <CameraIcon className="text-blue-500 h-6 w-6" />
        </div>

        <div className="w-full truncate">
          {/* Status */}
          <div className="flex flex-row">
            <h3 className="text-xs1 items-center flex font-normal text-gray-400">
              <svg
                className={`mr-1 italic h-2 w-2 ${
                  camera?.isActive ? "text-green-500" : "text-gray-400"
                }`}
                fill="currentColor"
                viewBox="0 0 8 8"
              >
                <circle cx={4} cy={4} r={3} />
              </svg>
              {camera?.isActive ? "Active" : "Inactive"}
            </h3>
          </div>

          {/* Title */}
          <div
            onClick={onClickView}
            className={`text-gray-600 font-medium flex flex-row justify-between blueAndBold ${
              isEditState ? "" : "cursor-pointer"
            }`}
          >
            <h1 className="mr-auto truncate text-ellipsis font-bold text-quinary text-base underline uppercase">
              {camera?.cameraModel || "No Camera details"}{" "}
              {camera?.cameraMake || ""}
            </h1>
          </div>

          {/* Install Date */}
          <h2 className="text-xxs text-gray-600 truncate">
            {camera?.cameraInstallDate
              ? moment(camera.cameraInstallDate).format("MMMM D, YYYY")
              : "No Install Date"}
          </h2>
        </div>

        {/* Menu */}
        {isEditState && (
          <div className="flex justify-end w-25">
            <Menu as="div" className="flex">
              <div>
                <Menu.Button>
                  <EllipsisHorizontalCircleIcon
                    className="h-4 w-4 text-primary rounded-full hover:bg-primary hover:text-white"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute z-50 mt-2 w-24 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                  {!editHidden && (
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className=""
                            onClick={(e) => {
                              onClickEdit();
                              e.preventDefault();
                            }}
                            disabled={false}
                          >
                            <label className="flex flex-cols underline cursor-pointer text-quaternary text-xs fontLabel font-semibold">
                              <PencilSquareIcon className="h-4 w-4 text-quaternary" />
                              Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  )}

                  {!hideDelete &&
                    hasDeletePermission &&
                    camera.isActive === true &&
                    typeof onClickDelete === "function" && (
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            type="button"
                            onClick={() => {
                              onClickDelete();
                            }}
                          >
                            <label className="flex flex-cols underline cursor-pointer text-secondary text-xs fontLabel font-semibold">
                              <TrashIcon className="h-4 w-4 text-secondary" />
                              Deactivate
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    )}
                  {!hideRemove && typeof onClickRemove === "function" && (
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onClickRemove();
                            }}
                          >
                            <label className="flex flex-cols underline cursor-pointer text-red-600 text-xs fontLabel font-semibold">
                              <TrashIcon className="h-4 w-4 text-red-600" />
                              Remove
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        )}
      </div>
    </div>
  );
};

export default CameraCard;
